import styled from 'styled-components'
import { Header1 } from './text/headers'
import { FC } from 'react'
import React from 'react'

const Container = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`

const VerticalDivider = styled.div`
    height: 32px;
    width: 0.6px;
    background-color: ${(p) => p.theme.colors.tertiary.tertiary600};
`

const Subtitle = styled.span`
    color: ${(p) => p.theme.colors.primary.default};
    font-size: 1em;
    line-height: 1em;
    font-weight: ${(p) => p.theme.fontWeight.semiBold};
    letter-spacing: -0.45px;
    align-self: center; /* This ensures it centers with the logo if needed */
`

export const Logo: FC = () => {
    return (
        <Container>
            <Header1>Tuhi</Header1>
            <VerticalDivider />
            <Subtitle>
                Clinical Consults <br /> and Note Taking
            </Subtitle>
        </Container>
    )
}
